import { VisuallyHiddenInput } from "Shared/Components/Form/CustomFormComponent/FormUploadButton";
import { Edit } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import type React from "react";
import {
	type Control,
	Controller,
	type FieldValues,
	type Path,
} from "react-hook-form";

type FormUploadGeneralProps<FormType extends FieldValues> = {
	onChange: (value: File | FileList | string) => void;
	control: Control<FormType>;
	name: Path<FormType>;
	children: React.ReactElement;
	multiple?: boolean;
	disabled?: boolean;
	accept?: string;
};

export const FormUploadGeneral = <FormType extends FieldValues>({
	onChange,
	name,
	control,
	children,
	multiple,
	disabled,
	accept,
}: FormUploadGeneralProps<FormType>) => {
	return (
		<Controller
			name={name}
			control={control}
			render={({ field }) => (
				<Box tabIndex={-1} sx={{ background: "none !important" }}>
					<Button
						component="label"
						tabIndex={-1}
						sx={{
							background: "none !important",
							mt: "0 !important",
							p: 0,
							borderRadius: "50%",
							"&:hover .edit-icon": {
								opacity: 1,
							},
						}}
					>
						{children}
						<Box
							className="edit-icon"
							sx={{
								position: "absolute",
								right: 0,
								bottom: 0,
								backgroundColor: "background.paper",
								borderRadius: "50%",
								padding: "2px",
								opacity: 0,
								transition: "opacity 0.2s ease-in-out",
								boxShadow: 1,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<Edit fontSize="small" />
						</Box>
						<VisuallyHiddenInput
							type="file"
							accept={accept}
							onChange={(event) => {
								const files = event.target.files;
								const value = multiple ? files : files?.[0] || "";

								onChange?.(value ?? "");
								field.onChange(value ?? "");
							}}
							value={""}
							multiple={multiple}
							disabled={disabled}
						/>
					</Button>
				</Box>
			)}
		/>
	);
};
